import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import ReactStringReplace from 'react-string-replace'

class SharedFileDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {isSharedFileSettingLoaded: false}
  }
  componentWillMount () {
    this.load('SharedFileSetting')
  }
  load (target) {
    const onSuccess = (res) => {
      const {params} = this.props.match
      const id = params.id
      const systemSettingValue = res.body.data.systemSettingValue.filter((e) => e.id === id)[0]
      this.setState({
        ['is' + target + 'Loaded']: true,
        [target]: systemSettingValue
      })
    }
    const params = {
      command: 'get',
      systemSettingName: target
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  deleteSharedFile () {
    const {params} = this.props.match
    const id = params.id
    const onSuccessToGet = (res) => {
      const systemSettingValue =
        res.body.data.systemSettingValue.filter((e) => e.id !== id)
      const sorter = (a, b) => {
        const dateA = a.year * 100000000 + a.month * 1000000 + a.day * 10000 + a.hour * 100 + a.minutes
        const dateB = b.year * 100000000 + b.month * 1000000 + b.day * 10000 + b.hour * 100 + b.minutes
        if (dateA < dateB) return 1
        if (dateA > dateB) return -1
        return 0
      }
      const paramsToSet = {
        command: 'set',
        systemSettingName: 'SharedFileSetting',
        systemSettingValue: systemSettingValue.sort(sorter)
      }
      const onSuccessToPost = (res) => {
        Window.alert('削除処理を実行しました', () => {
          this.props.history.push('/' + this.userRoleUrl + '/shared_files/')
          Window.closeDialog()
        })
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
    }
    const paramsToGet = {
      command: 'get',
      systemSettingName: 'SharedFileSetting'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet)
  }
  onPageMenuClicked (name) {
    const id = this.state.SharedFileSetting.id
    switch (name) {
      case 'back':
        this.props.history.push('/' + this.userRoleUrl + '/shared_files/')
        break
      case 'edit':
        this.props.history.push('/' + this.userRoleUrl + '/shared_files/edit/' + id)
        break
      case 'delete':
        Window.confirm('本当に削除処理を実行しますか?', () => {
          this.deleteSharedFile()
        })
        break
      default:
        break
    }
  }
  onFormButtonClicked (name) {
    switch (name) {
      case 'download':
        // ダウンロード処理
        const paramsToSet = {
          command: 'getS3GetObjectPresignedUrl',
          fileName: this.state.SharedFileSetting.filename
        }
        const onSuccessToPost = (res) => {
          const url = res.body.data
          const link = document.createElement('a')
          link.download = this.state.SharedFileSetting.filename
          link.href = url
          link.click()
        }
        AWSAPI.apiPost(this.userRole, this.apiUrlToDownlaod, paramsToSet, onSuccessToPost)
        break
      default:
        break
    }
  }
  convHttpLink (text) {
    const regExp = /(https?:\/\/\S+)/g
    return ReactStringReplace(text, regExp, (match, i) => (
      <a key={text} href={match} target='_blank'>{match}</a>
    ))
  }
  renderSharedFileDetail () {
    if (!this.state.isSharedFileSettingLoaded) {
      return <Loading />
    }
    const sharedFile = this.state.SharedFileSetting
    return (
      <fieldset>
        <legend>事務局からの共有ファイル - 詳細</legend>
        <br />
        <div className='control-group row'>
          <label className='span3'>最終更新日</label>
          <div className='span13'>
            {sharedFile.year} / {sharedFile.month} / {sharedFile.day}
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>最終更新時刻</label>
          <div className='span13 row'>
            {sharedFile.hour}<span className='kw-info-unit'>時</span>
            {sharedFile.minutes}<span className='kw-info-unit'>分</span>
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>ファイル名</label>
          <div className='span13'>
            {sharedFile.title}
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>説明</label>
          <div className='span13'>
            {this.convHttpLink(this.nl2br(sharedFile.description))}
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3' />
          <div className='span13'>
            <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('download', e)} >ダウンロード</button>
          </div>
        </div>
      </fieldset>
    )
  }
  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }
  render () {
    const informationDetail = this.renderSharedFileDetail()
    const editButton = this.isShowingEditButton
      ? (
        <li className='kw-btn-area'>
          <button id='edit-button' rel='tooltip' title='編集' data-placement='bottom' className='kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit', e)} >
            <i className='icon-edit icon-large' /><span>編集</span>
          </button>
        </li>
      )
      : ''
    const deleteButton = this.isShowingDeleteButton
      ? (
        <li key='ban' className='kw-btn-area'>
          <button id='delete-button' rel='tooltip' title='削除' data-placement='bottom' className='kw-btn-danger' onClick={(e) => this.onPageMenuClicked('delete', e)} >
            <i className='icon-remove icon-large' /><span>削除</span>
          </button>
        </li>
      )
      : ''
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>事務局からの共有ファイル - 詳細<br />
                    <small>こちらで事務局からの共有ファイルを確認できます。</small>
                  </h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                  {editButton}
                  {deleteButton}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container form-horizontal'>
          {informationDetail}
        </section>
      </div>
    )
  }
}

export default SharedFileDetail



// WEBPACK FOOTER //
// ./src/common/pages/secure/SharedFileDetail.js